// Shapes returned by /api/admin/* (see server/routes/adminDashboard.js)

export interface RenderRow {
  id: number;
  renderedAt: string | null;
  chart: string;
  chartDate: string;
  /** Canonical chart week (YYYY-MM-DD when parseable, else raw text) */
  chartWeek: string;
  orientation: string;
  language: string;
  s3Link: string | null;
  runNumber: number;
  isRerun: boolean;
  billable: boolean;
  overridden: boolean;
  overrideNote: string | null;
}

export interface Breakdown {
  key: string;
  billable: number;
  reruns: number;
}

export interface VersionBreakdown {
  chart: string;
  orientation: string;
  language: string;
  billable: number;
  reruns: number;
}

export interface Metrics {
  bucket: 'week' | 'month';
  totals: { billable: number; reruns: number; undated: number; all: number };
  byChart: Breakdown[];
  byOrientation: Breakdown[];
  byLanguage: Breakdown[];
  byVersion: VersionBreakdown[];
  series: { bucket: string; billable: number; reruns: number }[];
}

// from/to are PT calendar dates as YYYY-MM-DD; null = unbounded
export interface DashboardFilters {
  from: string | null;
  to: string | null;
  chart: string | null;
  orientation: string | null;
  language: string | null;
}

export const EMPTY_FILTERS: DashboardFilters = {
  from: null,
  to: null,
  chart: null,
  orientation: null,
  language: null,
};

// ---- Access log (see server/routes/adminDashboard.js /access-log) ----------

export interface AccessLogEntry {
  id: number;
  email: string | null;
  method: string;
  path: string;
  status: number | null;
  ip: string | null;
  userAgent: string | null;
  durationMs: number | null;
  at: string;
  /** PT-formatted timestamp, 'YYYY-MM-DD HH:MM:SS' */
  atPt: string;
}

export interface AccessLogSummaryRow {
  email: string | null;
  day: string;
  requests: number;
  distinctPaths: number;
  distinctIps: number;
  /** First hit that day, PT 'HH:MM:SS' */
  firstPt: string;
  /** Last hit that day, PT 'HH:MM:SS' */
  lastPt: string;
}

export interface AccessLogFilters {
  from: string | null;
  to: string | null;
  email: string | null;
  method: string | null;
}

export const EMPTY_ACCESS_FILTERS: AccessLogFilters = {
  from: null,
  to: null,
  email: null,
  method: null,
};
